import React from 'react';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { otherDegreeOptions, theologicalDegreeOptions, theologicalSchools } from './models/form-models';
import { FormGroup } from '../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';


interface Props {
    settings: ClergyBioSettings;
    id: string;
    arrayField: string;
    formikProps: FormikProps<any>;
    errors?: any;
    isOtherEducation?: boolean;
    setList?: any;
}

export const Other = 'Other';

function ClergyBioEducationItem(props: Props) {
    const buttonClasses = buttonStyles();
    const { settings, arrayField, id, formikProps, isOtherEducation, setList } = props;
    const mappedInstitution = theologicalSchools?.map(a => { return { value: a, text: a }; });
    const mappedDegrees = (isOtherEducation ? otherDegreeOptions : theologicalDegreeOptions).map(a => { return { value: a, text: a }; });

    const remove = () => {
        const list = formikProps?.values[arrayField];
        list.splice(Number(id), 1);
        const copy = { ...formikProps?.values };
        copy[arrayField] = list;
        setList(copy);
    };

	return (
		<ContentSpacer>
			<FormGroup>
			{
				isOtherEducation ?
					<FormField
						name={`${arrayField}[${id}].institution`}
						label={settings?.institutionLabel}
						touched={formikProps.touched}
						component='input'
						required
						errors={formikProps.errors}
					/> :
					<FormField
						name={`${arrayField}[${id}].institution`}
						label={settings?.institutionLabel}
						component='input'
						options={mappedInstitution}
						errors={formikProps.errors}
						touched={formikProps.touched}
						select
						required
					/>
			}
			{
				(formikProps?.values[arrayField][id]?.institution === Other && !isOtherEducation) &&
				<FormField
					name={`${arrayField}[${id}].institutionOther`}
					label={settings?.otherInstitutionLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
				/>
			}
			<FormField
				name={`${arrayField}[${id}].degree`}
				label={settings?.degreeLabel}
				component='input'
				options={mappedDegrees}
				errors={formikProps.errors}
				touched={formikProps.touched}
				select
			/>
			{
				formikProps?.values[arrayField][id]?.degree === Other &&
				<FormField
					name={`${arrayField}[${id}].degreeOther`}
					label={settings?.otherDegreeLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
				/>
			}
			<FormField
				name={`${arrayField}[${id}].field`}
				label={settings?.fieldLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
			/>
			<FormField
				name={`${arrayField}[${id}].year`}
				label={settings?.yearLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}

                />
                <div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>
            </FormGroup>
        </ContentSpacer>
    );
}

ClergyBioEducationItem.defaultProps = {
    errors: null,
    isOtherEducation: false,
    setList: null,
};
export default ClergyBioEducationItem;